import $ from "jquery";

export function validateNonEmptyRequiredInputs($form: JQuery) {
  let inputNotEmpty = 0;
  const $requiredInputs = $form.find(
    'input[aria-required="true"], input[required]'
  );

  $requiredInputs.each(function () {
    const $this = $(this);

    if ($this.val()) {
      inputNotEmpty++;
    }
  });

  if (inputNotEmpty === $requiredInputs.length) {
    $form.find("#btSubmit").removeClass("disabled");
  } else {
    $form.find("#btSubmit").addClass("disabled");
  }
}

export function inputForm(input: HTMLInputElement): HTMLFormElement | null {
  return $(input).parents("form")[0];
}

export function appendHiddenValueToForm(
  name: string,
  value: any,
  form: HTMLFormElement
) {
  const $form = $(form);
  const $input = $form.find(`input[type="hidden"][name="${name}"]`);

  if ($input.length > 0) {
    $input.val(value);
  } else {
    $form.append(`<input type="hidden" name="${name}" value="${value}" />`);
  }
}

export function awaitBeforeUserCanSubmit(
  input: HTMLInputElement,
  callback: (done: CallableFunction) => {}
) {
  const $form = $(input).parents("form");
  // disable submit button
  const disabledInterval = setInterval(
    () => $form.find("#btSubmit").addClass("disabled"),
    10
  );
  // do the pending tasks
  callback(() => {
    clearInterval(disabledInterval);
    // verify required fields and re-enable submit button
    validateNonEmptyRequiredInputs($form);
  });
}
